import { Nav } from "react-bootstrap";
import "./footer.css";
import { NavLink, Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  // hide footer for settings pages
  if (location.pathname.startsWith("/settings")) {
    return null;
  }

  return (
    <div className="footer">
      <div className="frame">
        <div className="div">
          <div className="text-wrapper">
            Copyright &copy; {currentYear} Network Rail
          </div>
        </div>
        <div className="div">
          <div className="div-wrapper">
            <NavLink
              style={{ textDecoration: "none" }}
              to="/terms-of-use"
              className="footer-details"
            >
              <div className="text-wrapper-2">Terms of Use</div>
            </NavLink>
          </div>
          <div className="frame-2">
            <NavLink
              style={{ textDecoration: "none" }}
              to="/privacy-notice"
              className="footer-details"
            >
              <div className="text-wrapper-2">Privacy Notice</div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
